import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ImportantDatesAndFileAssignment, ImportantDatePayload } from '../../disclosure/models/importantDates';
import { MessageService } from 'primeng/api';
import { APP_ENV } from 'apps/cmg-clear2-ui/src/environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class ImportantDateService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environment = inject(APP_ENV);
  private readonly _messageService = inject(MessageService);

  getImportantDate(fileDataId: number) {
    const url = `${this._environment?.retail?.apiUrl}/importantdate/getimportantdate/v2/${fileDataId}`;
    return this._httpClient.get<ImportantDatesAndFileAssignment>(url);
  }

  requestWithdrawal(fileDataId: number) {
    const url = `${this._environment?.retail?.apiUrl}/importantdate/requestwithdrawal/${fileDataId}`;
    return this._httpClient.post(url, {});
  }

  updateImportantDates(payload: ImportantDatePayload) {
    const url = `${this._environment?.retail?.apiUrl}/importantdate/update`;
    return this._httpClient.post(url, payload);
  }
}
